module.exports = "<div>\n  <core-helpers-box-http-error [code]=\"404\" [message]=\"'Not found. Check your URL.'\"></core-helpers-box-http-error>\n</div>\n"